import { render, staticRenderFns } from "./qyEmployee.vue?vue&type=template&id=1b85d0c6&scoped=true&"
import script from "./qyEmployee.vue?vue&type=script&lang=js&"
export * from "./qyEmployee.vue?vue&type=script&lang=js&"
import style0 from "./qyEmployee.vue?vue&type=style&index=0&id=1b85d0c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b85d0c6",
  null
  
)

export default component.exports